// Web version of AdView - ads are not supported on web
const AdView = () => {
  return null;
};

export default AdView;
